export default class SimilarityMeasure {
  measure(g1, g2) {}
}
